export const getGiftCardBlockingMessage = ({ giftCard, errorMessage, t }) => {
  if (errorMessage) return errorMessage
  if (!giftCard) return null
  if (Number(giftCard.remaining_amount) > 0) return null

  return t('Esta tarjeta regalo no tiene saldo disponible y no se puede anular.')
}
